module.exports = __webpack_public_path__ + "static/media/jacksonville-catering-1.69ecc298.jpg";